// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ctKb","inner":"Footer_inner__k3aPr","nextIcon":"Footer_nextIcon__32HiJ","innerLeft":"Footer_innerLeft__SXfmP"};